<template>
  <div>
    <div id="payment-size">
      <line-chart v-if="groupSize != ''" :line-data="groupSize" :options="options"/>
    </div>
    <br>
    <div id="cakeUse">
      <bar-chart v-if="groupIncrease != ''" :bar-data="groupIncrease"/>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/reports/line-chart.vue';
import BarChart from '@/components/reports/bar-chart.vue';
import axios from 'axios';
import { HOST_URL, API_V1 } from '@/config/api';


export default {
  components: {
    LineChart,
    BarChart
  },
  mounted(){
    axios.get(`${HOST_URL}${API_V1}/reports/group/dau`)
    .then(response => {
      this.setGroupSize(response.data)
    }).catch(error=> {
      console.log(error)
    })

    axios.get(`${HOST_URL}${API_V1}/reports/group/increase_size`)
    .then(response => {
      this.setGroupIncrease(response.data)
    }).catch(error=> {
      console.log(error)
    })
  },
  data () {
    return {
      groupSize: "",
      groupIncrease: "",
      chartData: {
        labels: ["Babol",	"Cabanatuan",	"Daegu",	"Jerusalem",	"Fairfield",	"New York",	"Gangtok", "Buenos Aires", "Hafar Al-Batin", "Idlib"],
        datasets: [
          {
            label: 'Line Chart',
            data: [600,	1150,	342,	6050,	2522,	3241,	1259,	157,	1545, 9841],
            fill: false,
            borderColor: '#2554FF',
            backgroundColor: '#2554FF',
            borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    setGroupSize(data){
      this.groupSize = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
            fill: false,
            borderColor: '#2554FF',
            backgroundColor: '#2554FF',
            borderWidth: 1
          }
        ]
      }
    },
    setGroupIncrease(data){
      this.groupIncrease = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
						pointBackgroundColor: 'white',
						borderWidth: 1,
						pointBorderColor: '#249EBF',
            backgroundColor: '#f87979',
          }
        ]
      }
    },
    setGroupMemberSize(data){
      this.groupMemberSize = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
						pointBackgroundColor: 'white',
						borderWidth: 1,
						pointBorderColor: '#249EBF',
            backgroundColor: '#f87979',
          }
        ]
      }
    },
    setGroupRetentionRatio(data){
      this.retentionRatio = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
						pointBackgroundColor: 'white',
						borderWidth: 1,
						pointBorderColor: '#249EBF',
            backgroundColor: '#f87979',
          }
        ]
      }
    },
    setGroupStoryShipSize(data){
      this.groupStoryShipSize = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
						pointBackgroundColor: 'white',
						borderWidth: 1,
						pointBorderColor: '#249EBF',
            backgroundColor: '#f87979',
          }
        ]
      }
    },
    setGroupStoryShipAndMemberSize(data){
      this.groupStoryShipAndMemberSize = {
        labels: data.labels,
        datasets: [
          {
            label: data.data_name,
            data: data.datasets,
						pointBackgroundColor: 'white',
						borderWidth: 1,
						pointBorderColor: '#249EBF',
            backgroundColor: '#f87979',
          }
        ]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
